<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="Form Not Found" :active.sync="form_not_found">
      <p>Form with Message ID  {{ $route.params.id }} not found.</p> <br>
      <p><b>List <router-link :to="'/staging/form'" class="text-inherit underline">All Forms</router-link></b></p>
    </vs-alert>

    <div id="user-data" v-if="form">

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full mb-base">
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-chip style="float: right" color="primary">
                  <vs-avatar icon-pack="feather" icon="icon-message-circle" color />
                  <span><b>{{ form.MESSAGEID }}</b></span>
                </vs-chip>
                <vs-chip style="float: right" color="success">
                  <vs-avatar icon-pack="feather" icon="icon-hash" color />
                  <span><b>{{ form.PRODID }}</b></span>
                </vs-chip>
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="ClipboardIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">WORK ORDER</span>
                </div>
                <vs-divider />
              </div>
            </div>
            <vs-avatar class="mr-3" style="float:right" size="100px" :src="center_img" />
            <table>
              <tr>
                <td class="font-semibold">PRD #</td>
                <td><b>{{ form.PRODID }}</b></td>
              </tr>
              <tr>
                <td class="font-semibold">ITEM ID</td>
                <td>{{ form.ITEMID }}</td>
              </tr>
              <tr>
                <td class="font-semibold">ITEM NAME</td>
                <td>{{ form.ITEMNAME }}</td>
              </tr>
              <tr>
                <td class="font-semibold">DELIVERY DATE</td>
                <td>{{ moment(form.DLVDATE).format('DD MMMM YYYY') }}</td>
              </tr>
              <tr>
                <td class="font-semibold">BATCH ID</td>
                <td>
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span><b>B</b></span>
                      </div>
                    </template>
                    <vs-input v-model="form.BATCHID" placeholder="Batch ID" />
                  </vx-input-group>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">QUANTITY</td>
                <td>
                  <vx-input-group>
                    <vs-input v-model="form.QTY" :danger="isNaN(form.QTY)" />
                    <template slot="append">
                      <div class="append-text bg-primary">
                        <span style="width:20px"><b>kg</b></span>
                      </div>
                    </template>
                  </vx-input-group>
                </td>
              </tr>
            </table>
            <vs-button id="btn-raf-save"
                       class="vs-con-loading__container"
                       @click="saveRAF"
                       icon-pack="feather"
                       :icon="btnRAF.icon" :color="btnRAF.color"
                       :disabled="!isChangeRAF"
                       style="float:right">{{ btnRAF.text }}</vs-button>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full mb-base">
          <vx-card :card-background="'linear-gradient(120deg ,rgba(247,97,161,0.5), rgba(140,27,171,.8)), url(' + center_img + ')'" title-color="#fff"
                   content-color="#fff">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-chip style="float: right" color="warning">
                  <vs-avatar icon-pack="feather" icon="icon-sun" color="warning" />
                  <span><b>{{ form.center.WORKCENTERID }}</b></span>
                </vs-chip>
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="HomeIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">WORK CENTER</span>
                </div>
                <vs-divider color="white" />
              </div>
            </div>
            <table>
              <tr>
                <td class="font-semibold">Work Center</td>
                <td>{{ form.center.WORKCENTERNAME }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Operation ID</td>
                <td>{{ form.center.OPRID }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Operation Hours</td>
                <td>{{ form.route.HOURS ? form.route.HOURS + ' hours' : '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Good Quantity</td>
                <td>{{ form.route.QTYGOOD ? form.route.QTYGOOD + ' kg' : '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Error Quantity</td>
                <td>{{ form.route.QTYERROR ? form.route.QTYERROR + ' kg' : '-' }}</td>
              </tr>
              <tr>
                <td class="font-semibold">MA</td>
                <td>{{ form.route.MA ? form.route.MA : '-' }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col w-full mb-base">
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-chip style="float: right" color="warning">
                  <vs-avatar icon-pack="feather" icon="icon-box" color />
                  <span v-if="outputType"><b>{{ outputType }}</b></span>
                </vs-chip>
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="PackageIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">MATERIALS</span>
                </div>
                <vs-divider class="mt-6" />
              </div>
            </div>
            <vs-table ref="table" :data="material" stripe style="width: calc(100% + 3rem); margin: -1.5rem;" >
              <template slot="thead" class="text-center">
                <vs-th sort-key="ITEMID">ITEM</vs-th>
                <vs-th sort-key="BOMQTY">QUANTITY</vs-th>
                <vs-th sort-key="BATCHID">BATCH</vs-th>
                <vs-th sort-key="MESSAGETYPE">PROPOSED</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="'m' + idx" v-for="(tr, idx) in data" :state="tr.added ? 'warning' : null">
                  <vs-td>
                    <p><b>{{ tr.ITEMID }}</b> <br>
                      {{ tr.ITEMNAME }}</p>
                    <span style="font-size: 10px" v-if="tr.INVENTTRANSID">Inventory Transaction ID : {{ tr.INVENTTRANSID }}</span>
                  </vs-td>

                  <vs-td>
                    <vx-input-group>
                      <vs-input icon-pack="feather" icon="icon-download" icon-no-border v-model="tr.QTY" size="large" :danger="isNaN(tr.QTY)" />
                      <template slot="append">
                        <div class="append-text bg-primary">
                          <span style="width:27px"><b v-if="tr.BOMUNIT">{{ tr.BOMUNIT.replace(/\./g, "") }}</b></span>
                        </div>
                      </template>
                    </vx-input-group>
                  </vs-td>

                  <vs-td>
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text bg-primary">
                          <span><b>B</b></span>
                        </div>
                      </template>
                      <vs-input v-model="tr.BATCHID" size="large" placeholder="Batch ID" />
                    </vx-input-group>
                  </vs-td>

                  <vs-td>
                    <p class="mt-3 text-center">{{ tr.BOMQTY ? tr.BOMQTY + ' ' + tr.BOMUNIT : '' }}</p>
                  </vs-td>

                  <vs-td>
                    <div class="w-full flex">
                    <vs-button :id="'btn-material-save-'+tr.INVENTTRANSID"
                               :key="'s'+tr.INVENTTRANSID"
                               class="vs-con-loading__container"
                               @click="saveMaterial(tr)"
                               v-if="btnMaterial[tr.INVENTTRANSID]"
                               icon-pack="feather"
                               :icon="btnMaterial[tr.INVENTTRANSID].icon" :color="btnMaterial[tr.INVENTTRANSID].color"
                               :disabled="!isChangeMaterial(tr.INVENTTRANSID)" />
                      <vs-button :id="'btn-material-add-'+tr.INVENTTRANSID"
                                 :key="'a'+tr.INVENTTRANSID"
                                 class="vs-con-loading__container ml-2"
                                 @click="addMaterial(tr)"
                                 v-if="!tr.added"
                                 icon-pack="feather" icon="icon-plus" color="warning" />
                      <vs-button :id="'btn-material-del-'+tr.INVENTTRANSID"
                                 :key="'d'+tr.INVENTTRANSID"
                                 class="vs-con-loading__container ml-2"
                                 @click="deleteMaterial(tr)"
                                 v-if="tr.added"
                                 icon-pack="feather" icon="icon-trash" color="danger" />
<!--                    <vs-button :disabled="true" color="primary" type="gradient" icon-pack="feather" icon="icon-save">Save</vs-button>-->
                    </div>
                  </vs-td>
                </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </vx-card>
        </div>

        <div class="vx-col w-full mb-base">
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-chip style="float: right" color="warning">
                  <vs-avatar icon-pack="feather" icon="icon-box" color />
                  <span v-if="outputType"><b>{{ outputType }}</b></span>
                </vs-chip>
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="DatabaseIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Bin</span>
                </div>
                <vs-divider class="mt-6" />
              </div>
            </div>

            <vs-table ref="table" :data="form.bin" stripe style="width: calc(100% + 3rem); margin: -1.5rem;" >
              <template slot="thead" class="text-center">
                <vs-th sort-key="bin_no">BIN</vs-th>
                <vs-th sort-key="weight">WEIGHT</vs-th>
                <vs-th sort-key="rfid">CONTAINER</vs-th>
                <vs-th sort-key="updated_at">UPDATED</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="'b' + idx" v-for="(tr, idx) in data">
                  <vs-td>
                    <p class="text-center"><b>{{ tr.bin_no }}</b></p>
                  </vs-td>
                  <vs-td>
                    <vx-input-group>
                      <vs-input icon-pack="feather" icon="icon-download" icon-no-border v-model="tr.weight" size="large" :danger="isNaN(tr.weight)" />
                      <template slot="append">
                        <div class="append-text bg-primary">
                          <span style="width:20px"><b>kg</b></span>
                        </div>
                      </template>
                    </vx-input-group>
                  </vs-td>
                  <vs-td>
                    <p v-if="tr.rfid" class="text-center">🧺 {{ tr.rfid }}</p>
                  </vs-td>
                  <vs-td>
                    <p v-if="tr.updated_at">🕑 {{ moment(tr.updated_at).format('MMM DD, YYYY HH:mm A') }}</p>
                    <b v-if="tr.staff">👨‍🏭 #{{ tr.staff }}</b>
                  </vs-td>
                  <vs-td>
                    <vs-avatar :id="'btn-bin-save-'+tr.bin_no"
                               :key="'bs'+tr.bin_no"
                               class="vs-con-loading__container"
                               @click="saveBin(tr)"
                               v-if="btnBin[tr.bin_no]"
                               icon-pack="feather"
                               :icon="btnBin[tr.bin_no].icon" :color="btnBin[tr.bin_no].color"
                               :disabled="!isChangeBin(tr.bin_no)" />
                    <vs-avatar :id="'btn-bin-del-'+tr.bin_no"
                               :key="'b'+tr.bin_no"
                               class="vs-con-loading__container ml-2"
                               @click="promptDeleteBin(tr)"
                               icon-pack="feather" icon="icon-trash" color="danger" />
                  </vs-td>
                </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      id: this.$route.params.id,
      center_img: require('@/assets/images/center/furnace_300.jpg'),
      form_not_found: false,
      form: false,
      formI: false,
      material: false,
      materialI: false,
      bin: false,
      binI: false,
      outputType: null,
      savedRAF: false,
      btnRAF: {
        icon: 'icon-save',
        color: 'primary',
        text: 'Save'
      },
      savedMaterial: false,
      delMaterial: false,
      savedBin: false,
      delBin: false,
      btnMaterial: [],
      btnBin: []
    }
  },
  created () {
  },
  computed: {
    isChangeRAF () {
      // console.log(this.form.BATCHID, this.formI.BATCHID)
      // console.log(this.form.QTY, this.formI.QTY)
      return this.form.BATCHID !== this.formI.BATCHID || parseInt(this.form.QTY) !== parseInt(this.formI.QTY)
    }
  },
  mounted () {
    this.fetchForm()
  },
  methods: {
    fetchForm (change = 'all') {
      this.$vs.loading()
      this.$http.get('/api/staging/form/' + this.id)
        .then(({ data }) => {
          if (change === 'all') {
            this.form = data.form
            this.formI = {...data.form, material: data.form.material.map(m => ({...m}))}
          }

          if (change === 'all' || change === 'material') {
            this.material = data.form.material
            this.materialI = data.form.material.map(m => ({ ...m }))
            data.form.material.map(m => {
              this.btnMaterial[m.INVENTTRANSID] = { icon: 'icon-save', color: 'primary' }
            })
          }

          if (change === 'all' || change === 'bin') {
            this.bin = data.form.bin
            this.binI = data.form.bin.map(m => ({ ...m }))
            data.form.bin.map(m => {
              this.btnBin[m.bin_no] = { icon: 'icon-save', color: 'primary' }
            })
          }

          if (change === 'all') {
            this.outputType = this.textOutput(this.form.ITEMNAME)
            if (!data.form || !data.success) this.form_not_found = true
          }

          this.$vs.loading.close()
        })
        .catch(e => {
          this.$vs.loading.close()
          if (e.response.status === 404) {
            this.form_not_found = true
          } else {
            this.$vs.notify({
              title: 'Failed to fetch form',
              text: e.response.data.message || e.message,
              iconPack: 'feather',
              icon: 'icon-x',
              color: 'danger',
              timer: 1500
            })
          }
        })
    },
    loadingBtn (container, background = 'primary', color = '#fff', scale = 0.45) {
      this.$vs.loading({ background, color, container, scale })
    },
    saveRAF () {
      this.loadingBtn('#btn-raf-save')
      let patch = {
        PRODID: this.form.PRODID,
        WORKCENTERID: this.form.WORKCENTERID,
        BATCHID: this.form.BATCHID,
        QTY: this.form.QTY
      }
      this.$http.patch('/api/staging/raf/' + this.id, patch)
        .then(({ data }) => {
          console.log(data)
          this.$vs.notify({
            title: 'Saved',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            timer: 1500
          })
          this.$vs.loading.close('#btn-raf-save > .con-vs-loading')
          this.savedRAF = true
          this.btnRAF = { icon: 'icon-check', color: 'success', text: 'OK' }
          if (data.update && Object.keys(data.update[0]).length) this.formI = { ...this.formI, ...data.update[0] }

          setTimeout(() => {
            this.savedRAF = null
            this.btnRAF = { icon: 'icon-save', color: 'primary', text: 'Save' }
          }, 2000)
        })
        .catch(e => {
          this.$vs.loading.close('#btn-raf-save > .con-vs-loading')
          this.savedRAF = false
          this.btnRAF = { icon: 'icon-alert-circle', color: 'error', text: 'Retry' }

          this.$vs.notify({
            title: 'Failed to save data',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    addMaterial (material) {
      this.loadingBtn('#btn-material-add-' + material.INVENTTRANSID)
      let mat = this.material.find(i => i.INVENTTRANSID === material.INVENTTRANSID)
      let add = {
        PRODID: this.form.PRODID,
        INVENTTRANSID: mat.INVENTTRANSID,
        ITEMID: mat.ITEMID
      }
      this.$http.post('/api/staging/picking/' + this.id, add)
        .then(({ data }) => {
          console.log(data)
          this.$vs.notify({
            title: 'Added',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            timer: 1500
          })
          this.$vs.loading.close('#btn-material-add-' + material.INVENTTRANSID + ' > .con-vs-loading')
          // this.addMaterial = true
          if (data.created && Object.keys(data.created).length) {
            let idx = this.material.findIndex(i => i.INVENTTRANSID === data.created.INVENTTRANSID)
            this.materialI[idx] = data.created
            this.material[idx] = data.created
            this.btnMaterial[data.created.INVENTTRANSID] = { icon: 'icon-save', color: 'primary', text: 'Save' }
          }
          this.fetchForm('material')

          setTimeout(() => {
            // this.addMaterial = null
          }, 2000)
        })
        .catch(e => {
          this.$vs.loading.close('#btn-material-add-' + material.INVENTTRANSID + ' > .con-vs-loading')
          // this.addMaterial = false

          this.$vs.notify({
            title: 'Failed to add item',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    saveMaterial (material) {
      this.loadingBtn('#btn-material-save-' + material.INVENTTRANSID)
      let mat = this.material.find(i => i.INVENTTRANSID === material.INVENTTRANSID)
      let patch = {
        PRODID: this.form.PRODID,
        INVENTTRANSID: mat.INVENTTRANSID,
        BATCHID: mat.BATCHID,
        QTY: mat.QTY,
        ITEMID: mat.ITEMID
      }
      this.$http.patch('/api/staging/picking/' + this.id, patch)
        .then(({ data }) => {
          console.log(data)
          this.$vs.notify({
            title: 'Saved',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            timer: 1500
          })
          this.savedMaterial = true
          this.btnMaterial[material.INVENTTRANSID] = { icon: 'icon-check', color: 'success', text: 'OK' }
          if (data.update && Object.keys(data.update[0]).length) {
            let idx = this.material.findIndex(i => i.INVENTTRANSID === data.update[0].INVENTTRANSID)
            this.materialI[idx] = {
              ...data.update[0],
              BATCHID : data.update[0].BATCHID,
              QTY : data.update[0].QTY,
              BOMQTY: this.materialI[idx].BOMQTY
            }
            this.material[idx] = {
              ...data.update[0],
              BATCHID : data.update[0].BATCHID,
              QTY : data.update[0].QTY,
              BOMQTY: this.material[idx].BOMQTY
            }
          }
          this.$vs.loading.close('#btn-material-save-' + material.INVENTTRANSID + ' > .con-vs-loading')

          setTimeout(() => {
            this.savedMaterial = null
            this.btnMaterial[material.INVENTTRANSID] = { icon: 'icon-save', color: 'primary', text: 'Save' }
          }, 2000)
        })
        .catch(e => {
          this.$vs.loading.close('#btn-material-save-' + material.INVENTTRANSID + ' > .con-vs-loading')
          this.savedMaterial = false
          this.btnMaterial[material.INVENTTRANSID] = { icon: 'icon-alert-circle', color: 'error', text: 'Retry' }

          this.$vs.notify({
            title: 'Failed to save data',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    deleteMaterial (material) {
      this.loadingBtn('#btn-material-del-' + material.INVENTTRANSID)
      let mat = this.material.find(i => i.INVENTTRANSID === material.INVENTTRANSID)
      let del = {
        PRODID: this.form.PRODID,
        INVENTTRANSID: mat.INVENTTRANSID
      }
      this.$http.delete('/api/staging/picking/' + this.id, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }, data:del })
        .then(({ data }) => {
          console.log(data)
          this.$vs.notify({
            title: 'Deleted',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            timer: 1500
          })
          this.$vs.loading.close('#btn-material-del-' + material.INVENTTRANSID + ' > .con-vs-loading')
          this.delMaterial = true

          let idx = this.material.findIndex(i => i.INVENTTRANSID === del.INVENTTRANSID)
          if (idx !== -1) {
            this.materialI.splice(idx, 1)
            this.material.splice(idx, 1)
          }

          setTimeout(() => {
            this.delMaterial = null
          }, 2000)
        })
        .catch(e => {
          this.$vs.loading.close('#btn-material-del-' + material.INVENTTRANSID + ' > .con-vs-loading')
          this.delMaterial = false

          this.$vs.notify({
            title: 'Failed to delete item',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    saveBin (bin) {
      this.loadingBtn('#btn-bin-save-' + bin.bin_no)
      let patch = {
        PRODID: this.form.PRODID,
        bin_no: bin.bin_no,
        weight: bin.weight
      }
      this.$http.patch('/api/process/furnace/' + this.id + '/bin', patch)
        .then(({ data }) => {
          console.log(data)
          this.$vs.notify({
            title: 'Saved',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            timer: 1500
          })
          this.savedBin = true
          this.btnBin[bin.bin_no] = { icon: 'icon-check', color: 'success', text: 'OK' }
          if (data.update && Object.keys(data.update[0]).length) {
            let idx = this.bin.findIndex(i => i.bin_no === data.update[0].bin_no)
            this.binI[idx] = {
              ...data.update[0]
            }
            this.bin[idx] = {
              ...data.update[0]
            }
          }
          this.$vs.loading.close('#btn-bin-save-' + bin.bin_no + ' > .con-vs-loading')

          setTimeout(() => {
            this.savedBin = null
            this.btnBin[bin.bin_no] = { icon: 'icon-save', color: 'primary', text: 'Save' }
          }, 2000)
        })
        .catch(e => {
          this.$vs.loading.close('#btn-bin-save-' + bin.bin_no + ' > .con-vs-loading')
          this.savedBin = false
          this.btnBin[bin.bin_no] = { icon: 'icon-alert-circle', color: 'error', text: 'Retry' }

          this.$vs.notify({
            title: 'Failed to save data',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    promptDeleteBin (bin) {
      this.$swal
        .fire({
          title: 'Are you sure ?',
          html: `The bin no <b>${bin.bin_no}</b> will be removed`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it !'
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteBin(bin)
          }
        })
    },
    deleteBin (bin) {
      this.loadingBtn('#btn-bin-del-' + bin.bin_no)
      let del = {
        PRODID: this.form.PRODID,
        bin_no: bin.bin_no
      }
      this.$http.delete('/api/process/furnace/' + this.id + '/bin', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }, data:del })
        .then(({ data }) => {
          console.log(data)
          this.$vs.notify({
            title: 'Deleted',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            timer: 1500
          })
          this.$vs.loading.close('#btn-bin-del-' + bin.bin_no + ' > .con-vs-loading')
          this.delBin = true

          let idx = this.bin.findIndex(i => i.bin_no === del.bin_no)
          if (idx !== -1) {
            this.binI.splice(idx, 1)
            this.bin.splice(idx, 1)
          }

          setTimeout(() => {
            this.delBin = null
          }, 2000)
        })
        .catch(e => {
          this.$vs.loading.close('#btn-bin-del-' + bin.bin_no + ' > .con-vs-loading')
          this.delBin = false

          this.$vs.notify({
            title: 'Failed to delete bin',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    isChangeMaterial (invent) {
      if (this.material && this.material.length) {
        let prev = this.materialI.find(m => m.INVENTTRANSID === invent)
        let next = this.material.find(m => m.INVENTTRANSID === invent)
        if ((next.QTY && (parseInt(next.QTY) !== parseInt(prev.QTY))) || (next.BATCHID && (next.BATCHID !== prev.BATCHID))) {
          this.btnMaterial[next.INVENTTRANSID] = { icon: 'icon-save', color: 'primary', text: 'Save' }
          return true
        }
      }
      return false
    },
    isChangeBin (bin_no) {
      if (this.material && this.bin.length) {
        let prev = this.binI.find(m => m.bin_no === bin_no)
        let next = this.bin.find(m => m.bin_no === bin_no)
        if ((next.weight && (parseInt(next.weight) !== parseInt(prev.weight))) || (next.rfid && (next.rfid !== prev.rfid)) || (next.staff && (next.staff !== prev.staff))) {
          this.btnBin[next.bin_no] = { icon: 'icon-save', color: 'primary', text: 'Save' }
          return true
        }
      }
      return false
    },
    textOutput (ITEMNAME) {
      if (ITEMNAME.toLowerCase().includes('cast')) return 'CAST BAR'
      if (ITEMNAME.toLowerCase().includes('billet')) return 'BILLET'
      if (ITEMNAME.toLowerCase().includes('ball')) return 'HALF BALL'
      return null
    },
    moment (time, format = null) {
      return moment(time, format)
    }
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

.span-text-validation {
  height: 0;
  padding: 0;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}

</style>
